<div class="py-3">
  <!-- Product name with pricing badge -->
  <div class="mb-1.5">
    <a
      [routerLink]="['/products', item.product.id, 'edit']"
      class="text-sm font-medium  dark:text-gray-100 text-gray-900  hover:text-blue-600 dark:hover:text-blue-400 hover:underline cursor-pointer">
      {{ item.product.name }}
    </a>
    @if (displayDescription) {
      <div class="text-xs mt-0.5" [innerHTML]="displayDescription"></div>
    }
    <div class="mt-1 flex flex-wrap gap-1">
      @if (item.product.counts_to_500_deal) {
        <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-amber-100 text-amber-800 dark:bg-amber-900/30 dark:text-amber-200">
          <lucide-icon [name]="StarIcon" [size]="12" class="shrink-0"></lucide-icon>
          £500
        </span>
      }
      @if (item.product.inc_in_150_free) {
        <span class="inline-flex items-center gap-1 px-1.5 py-0.5 rounded text-[10px] font-semibold bg-fuchsia-100 text-fuchsia-800 dark:bg-fuchsia-900/30 dark:text-fuchsia-200">
          <lucide-icon [name]="GiftIcon" [size]="12" class="shrink-0"></lucide-icon>
          £150
        </span>
      }
    </div>
    @if (item.is_product_using_daily_price) {
      <lucide-icon
        [size]="14"
        [name]="Calendar"
        class="inline-block ml-1.5 text-blue-500 dark:text-blue-400"
        title="Product is using daily pricing for this event date">
      </lucide-icon>
    }
  </div>

  <!-- Variant selections -->
  <!-- TVG-159: Accommodation room variants are hidden on the Finance page; the
       single accommodation line and price still show. -->
  @if (!isAccommodation && item.variant_selections && item.variant_selections.length > 0) {
    <div class="space-y-1 mt-1">
      @for (selection of item.variant_selections; track selection.id) {
        <div class="text-xs">
          <div class="text-gray-600 dark:text-gray-400">
            <span class="text-gray-500 dark:text-gray-500">{{ selection.variant?.name }}:</span>
            <span class="ml-1 text-gray-700 dark:text-gray-300">{{ selection.variant_option?.name || 'Standard' }}</span>
          </div>
          @if (selection.variant_option?.description?.trim() && selection.variant_option?.description !== 'null') {
            <div class="mt-0.5 text-[11px] leading-snug text-gray-500 dark:text-gray-500 break-words" [innerHTML]="selection.variant_option?.description || ''"></div>
          }
          @if (selection.variant_option && getSelectionUnitPrice(selection) !== null && getSelectionUnitPrice(selection) !== 0 && selection.quantity) {
            <div class="flex items-center gap-1 font-medium mt-0.5"
                 [class.text-green-600]="getSelectionUnitPrice(selection) > 0"
                 [class.dark:text-green-400]="getSelectionUnitPrice(selection) > 0"
                 [class.text-red-600]="getSelectionUnitPrice(selection) < 0"
                 [class.dark:text-red-400]="getSelectionUnitPrice(selection) < 0">
              <span>
                {{ getSelectionUnitPrice(selection) > 0 ? '+' : '' }}£{{ getSelectionUnitPrice(selection) }} × {{ selection.quantity }}
                @if (selection.quantity > 1) {
                  = £{{ (getSelectionUnitPrice(selection) * selection.quantity).toFixed(2) }}
                }
              </span>
              @if (selection.variant_option.is_using_daily_price) {
                <lucide-icon
                  [size]="12"
                  [name]="Calendar"
                  class="text-blue-500 dark:text-blue-400"
                  title="Option is using daily pricing">
                </lucide-icon>
              } @else if (isOptionDiscontinued(selection.variant_option)) {
                <lucide-icon
                  [size]="12"
                  [name]="Calendar"
                  class="text-orange-500 dark:text-orange-400"
                  title="Discontinued for this event date">
                </lucide-icon>
              }
            </div>
          } @else if (selection.quantity && selection.quantity > 0 && ((selection.variant_option?.['effective_price'] ?? selection.variant_option?.price ?? 0) === 0)) {
            <div class="flex items-center gap-1 font-medium mt-0.5 text-gray-600 dark:text-gray-400">
              <span>
                £0 × {{ selection.quantity }}
                @if (selection.quantity > 1) {
                  = £0
                }
              </span>
            </div>
          } @else if (selection.variant_option?.is_using_daily_price) {
            <div class="mt-0.5">
              <lucide-icon
                [size]="12"
                [name]="Calendar"
                class="text-blue-500 dark:text-blue-400"
                title="Option is using daily pricing">
              </lucide-icon>
            </div>
          } @else if (selection.variant_option && isOptionDiscontinued(selection.variant_option)) {
            <div class="mt-0.5">
              <lucide-icon
                [size]="12"
                [name]="Calendar"
                class="text-orange-500 dark:text-orange-400"
                title="Discontinued for this event date">
              </lucide-icon>
            </div>
          } @else if (selection.quantity !== undefined && selection.quantity !== null) {
            <div class="flex items-center gap-1 font-medium mt-0.5 text-gray-600 dark:text-gray-400">
              <span>
                £0 × {{ selection.quantity }}
                @if (selection.quantity > 1) {
                  = £0
                }
              </span>
            </div>
          }
          @if (selection.notes) {
            <div class="text-blue-600 dark:text-blue-400 italic mt-1">{{ selection.notes }}</div>
          }
        </div>
      }
    </div>
  }
</div>
